export const QuestionsTextDE: QuestionsText = {
  relationship_status: {
    question: 'Was ist Ihr aktueller Beziehungsstatus?',
    options: [
      { value: 'single', label: 'Single' },
      {
        value: 'closed',
        label: 'Geschlossene Beziehung',
      },
      {
        value: 'open',
        label: 'Offene Beziehung',
      },
      { value: 'polyamorous', label: 'In mehreren Beziehungen' },
      { value: 'other', label: 'Andere' },
    ],
  },
  relationship_duration: {
    question:
      'Wie lange sind Sie bereits in dieser Beziehung (bei mehreren, die längste)?',
    labels: {
      min: 'weniger als ein Jahr',
      max: '50 Jahre und mehr',
    },
  },
  relationship_duration_single: {
    question:
      'Wie lange sind Sie bereits Single?',
    labels: {
      min: 'weniger als ein Jahr',
      max: '50 Jahre und mehr',
    },
  },
  gender: {
    question: 'Mit welchem Geschlecht identifizieren Sie sich?',
    options: [
      { value: 'female', label: 'Weiblich' },
      {
        value: 'male',
        label: 'Männlich',
      },
      // {
      //   value: 'intersexual',
      //   label: 'Intergeschlechtlich',
      // },
      { value: 'other', label: 'Divers (Trans, nonbinär, weitere)' },
    ],
  },
  sexual_orientation: {
    question: 'Welcher sexuellen Orientierung fühlen Sie sich zugehörig?',
    options: [
      { value: 'heterosexual', label: 'Heterosexuell' },
      {
        value: 'bisexual',
        label: 'Bisexuell',
      },
      {
        value: 'homosexual',
        label: 'Homosexuell',
      },
      { value: 'other', label: 'Weitere (pansexuell, etc.)' },
    ],
  },
  age: {
    question: 'Wie alt sind Sie?',
    options: [
      { value: 'age_18_to_29', label: '18 bis 29 Jahre' },
      { value: 'age_30_to_39', label: '30 bis 39 Jahre' },
      { value: 'age_40_to_49', label: '40 bis 49 Jahre' },
      { value: 'age_50_to_59', label: '50 bis 59 Jahre' },
      { value: 'age_60_to_69', label: '60 bis 69 Jahre' },
      { value: 'age_70_plus', label: '70 Jahre und älter' },
    ],
  },
  education: {
    question: 'Was ist Ihr höchster Bildungsabschluss?',
    options: [
      { value: 'compulsory', label: 'Obligatorische Schule' },
      {
        value: 'secondary_2',
        label: 'Sekundarstufe II (Berufslehre, Fachmittelschule, Gymnasium)',
      },
      {
        value: 'tertiary_job',
        label:
          'Tertiärstufe (höhere Berufsbildung, höhere Fachschule, eidg. Fachausweis)',
      },
      {
        value: 'tertiary_study',
        label: 'Tertiärstufe (Fachhochschule, PH, Universität)',
      },
      { value: 'other', label: 'Andere' },
    ],
  },
  satisfaction: {
    question: 'Wie zufrieden sind Sie insgesamt mit Ihrem Sexleben?',
    labels: {
      min: '0 - gar nicht zufrieden',
      max: '10 - sehr zufrieden',
    },
  },
  sex_frequency: {
    question:
      'Wie oft hatten Sie im letzten Monat Sex (jeglicher Art) mit einer Person?',
    options: [
      {
        value: 'never',
        label: 'Ich hatte im letzten Monat keinen Sex',
      },
      {
        value: 'one_to_two_times_month',
        label: '1-2x im Monat',
      },
      {
        value: 'three_to_four_times_month',
        label: '3-4x im Monat',
      },
      {
        value: 'two_to_three_times_week',
        label: '2-3x pro Woche',
      },
      {
        value: 'four_to_five_times_week',
        label: '4–5x pro Woche',
      },
      {
        value: 'six_to_seven_times_week',
        label: '6-7x pro Woche',
      },
      {
        value: 'more_than_seven_times_week',
        label: 'Mehr als 7x pro Woche',
      },
      {
        value: 'never_ever',
        label: 'Ich hatte noch nie Sex mit einer Person.',
      },
    ],
  },
  sex_frequency_desired: {
    question:
      'Wie häufig hätten Sie gerne Sex (jeglicher Art) mit einer Person verglichen mit Ihrer aktuellen Situation?',
    options: [
      {
        value: 'much_more',
        label: 'viel häufiger',
      },
      {
        value: 'more',
        label: 'häufiger',
      },
      {
        value: 'same',
        label: 'genau so oft',
      },
      {
        value: 'less',
        label: 'Weniger oft',
      },
      {
        value: 'much_less',
        label: 'viel weniger',
      },
      // {
      //   value: 'no_answer',
      //   label: 'keine Angabe',
      // },
    ],
  },
  orgasm_frequency_sex: {
    question:
      'Wie häufig kamen Sie beim Sex (jeglicher Art) mit einer Person im letzten Monat zu einem Orgasmus?',
    labels: {
      min: '0 - nie',
      max: '100% - immer',
    },
  },
  orgasm_frequency_desired: {
    question:
      'Wie häufig würden Sie beim Sex (jeglicher Art) mit einer Person gerne zu einem Orgasmus kommen verglichen mit Ihrer aktuellen Situation?',
    options: [
      {
        value: 'much_more',
        label: 'viel häufiger',
      },
      {
        value: 'more',
        label: 'häufiger',
      },
      {
        value: 'same',
        label: 'genau so oft',
      },
      {
        value: 'less',
        label: 'Weniger oft',
      },
      {
        value: 'much_less',
        label: 'viel weniger',
      },
      // {
      //   value: 'no_answer',
      //   label: 'keine Angabe',
      // },
    ],
  },
  pleasure_frequency_sex: {
    question:
      'Wie oft erlebten Sie im letzten Monat sexuelles Vergnügen beim Sex (jeglicher Art) mit einer Person?',
    labels: {
      min: '0 - nie',
      max: '100% - immer',
    },
  },
  masturbation_frequency: {
    question:
      'Wie oft haben Sie im letzten Monat masturbiert (Selbstbefriedigung)?',
    options: [
      {
        value: 'never',
        label: 'Ich habe im letzten Monat nicht masturbiert.',
      },
      {
        value: 'one_to_two_times_month',
        label: '1-2x im Monat',
      },
      {
        value: 'three_to_four_times_month',
        label: '3-4x im Monat',
      },
      {
        value: 'two_to_three_times_week',
        label: '2-3x pro Woche',
      },
      {
        value: 'four_to_five_times_week',
        label: '4–5x pro Woche',
      },
      {
        value: 'six_to_seven_times_week',
        label: '6-7x pro Woche',
      },
      {
        value: 'more_than_seven_times_week',
        label: 'mehr als 7x pro Woche',
      },
      {
        value: 'never_ever',
        label: 'Ich habe noch nie masturbiert.',
      },
    ],
  },
  orgasm_frequency_masturbation: {
    question:
      'Wie oft hatten Sie im letzten Monat einen Orgasmus beim Masturbieren?',
    labels: {
      min: '0 - nie',
      max: '100% - immer',
    },
  },
  pleasure_frequency_masturbation: {
    question:
      'Wie oft erlebten Sie im letzten Monat sexuelles Vergnügen (Genuss) beim Masturbieren?',
    labels: {
      min: '0 - nie',
      max: '100% - immer',
    },
  },
  group_agree: {
    question: 'Wie sehr stimmen Sie folgenden Aussagen zu:',
  },
  group_agree_like: {
    question: 'Männern gefällt Sex mehr als Frauen.',
    labels: {
      min: '0 – Stimme gar nicht zu',
      max: '5 – Stimme voll und ganz zu',
    },
  },
  group_agree_demand: {
    question: 'Frauen haben weniger Verlangen nach Sex als Männer.',
    labels: {
      min: '0 – Stimme gar nicht zu',
      max: '5 – Stimme voll und ganz zu',
    },
  },
  group_agree_think: {
    question: 'Frauen denken weniger häufig an Sex als Männer.',
    labels: {
      min: '0 – Stimme gar nicht zu',
      max: '5 – Stimme voll und ganz zu',
    },
  },
  genital_look: {
    question:
      'Mit dem Aussehen meines Genitals bin ich zufrieden. (Genital = primäre Geschlechtsorgane)',
    labels: {
      min: '0 – Trifft überhaupt nicht zu',
      max: '5 – Trifft voll und ganz zu',
    },
  },
  genital_function: {
    question:
      'Mit der Funktion meines Genitals bin ich zufrieden. (Genital = primäre Geschlechtsorgane)',
    labels: {
      min: '0 – Trifft überhaupt nicht zu',
      max: '5 – Trifft voll und ganz zu',
    },
  },
  realize_sexual_demands: {
    question:
      'Ich kann meine sexuellen Bedürfnisse während dem Sex (jeglicher Art) mit einer Person wahrnehmen.',
    labels: {
      min: '0 – Trifft überhaupt nicht zu',
      max: '5 – Trifft voll und ganz zu',
    },
  },
  communicate_needed_mood: {
    question:
      'Ich kann einer Person vermitteln, welche sexuelle Stimulation ich zum Erreichen eines Orgasmus benötige.',
    labels: {
      min: '0 – Trifft überhaupt nicht zu',
      max: '5 – Trifft voll und ganz zu',
    },
  },
  right_to_orgasm: {
    question: 'Ich habe Anspruch, beim Sex einen Orgasmus zu erleben.',
    labels: {
      min: '0 – Stimme gar nicht zu',
      max: '5 – Stimme voll und ganz zu',
    },
  },
}
